// 🌐 사이트 공통 설정

/**
 * 사용자 사이트의 공개 도메인 (추적 링크 생성 등 외부 공유용 URL의 기준)
 * - 개발 환경(localhost)에서도 실제 배포 도메인으로 링크를 생성하기 위해 상수로 관리
 * - 환경변수 VITE_PUBLIC_SITE_ORIGIN으로 재정의 가능
 */
export const PUBLIC_SITE_ORIGIN: string =
  import.meta.env.VITE_PUBLIC_SITE_ORIGIN || 'https://event.dwt.kr';
